import { IChannelLLMTemplate, LLMTemplateSource } from '@/models/llmTemplate.model';

export const getLLMChannelTemplateSourceTagProps = (template?: IChannelLLMTemplate | null) => {
  if (template?.source === LLMTemplateSource.INDIVIDUAL) {
    return { color: 'processing', labelKey: 'llm_template_source_individual' };
  }

  return { color: 'default', labelKey: 'llm_template_source_base' };
};
